var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18945 10.7799C8.99945 10.7799 8.80946 10.7098 8.65946 10.5598L7.03731 8.9377C6.86302 8.7996 6.75 8.58648 6.75 8.3501C6.75 8.30881 6.75345 8.26824 6.76007 8.22865C6.78266 8.07476 6.85246 7.92684 6.96945 7.80985L8.65946 6.11984C8.94946 5.82984 9.42945 5.82984 9.71945 6.11984C10.0095 6.40984 10.0095 6.88984 9.71945 7.17984L9.29921 7.6001H14.9C16.2 7.6001 17.25 8.66013 17.25 9.95013V11.7201C17.25 12.1301 16.91 12.4701 16.5 12.4701C16.09 12.4701 15.75 12.1301 15.75 11.7201V9.95013C15.75 9.48013 15.37 9.1001 14.9 9.1001H9.31969L9.71945 9.49985C10.0095 9.78985 10.0095 10.2698 9.71945 10.5598C9.56945 10.7098 9.37945 10.7799 9.18945 10.7799Z",
    fill: "#5D9FE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10001 16.41H14.6799L14.28 16.8099C13.99 17.0999 13.99 17.5799 14.28 17.8699C14.43 18.0199 14.62 18.0899 14.81 18.0899C15 18.0899 15.2 18.0199 15.34 17.8699L16.9607 16.2492C17.1361 16.1112 17.25 15.8973 17.25 15.66C17.25 15.6094 17.2448 15.5598 17.2349 15.5118C17.2085 15.3676 17.1402 15.2301 17.03 15.1199L15.34 13.4299C15.05 13.1399 14.57 13.1399 14.28 13.4299C13.99 13.7199 13.99 14.1999 14.28 14.4899L14.7001 14.91H9.10001C8.63001 14.91 8.25 14.5301 8.25 14.0601V12.29C8.25 11.88 7.91 11.54 7.5 11.54C7.09 11.54 6.75 11.88 6.75 12.29V14.0601C6.75 15.3501 7.80001 16.41 9.10001 16.41Z",
    fill: "#5D9FE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12C1.25 17.93 6.07 22.75 12 22.75C17.93 22.75 22.75 17.93 22.75 12C22.75 6.07 17.93 1.25 12 1.25C6.07 1.25 1.25 6.07 1.25 12ZM2.75 12C2.75 6.9 6.9 2.75 12 2.75C17.1 2.75 21.25 6.9 21.25 12C21.25 17.1 17.1 21.25 12 21.25C6.9 21.25 2.75 17.1 2.75 12Z",
    fill: "#5D9FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatCircle);
export default __webpack_public_path__ + "static/media/Repeat_Circle.516fec97d11fc63fbd878468e62d3aa2.svg";
export { ForwardRef as ReactComponent };